export var StoreItemValidityEnum;
(function (StoreItemValidityEnum) {
    StoreItemValidityEnum["VALID"] = "VALID";
    StoreItemValidityEnum["INVALID"] = "INVALID";
    StoreItemValidityEnum["MISSING_ITEM"] = "MISSING_ITEM";
    StoreItemValidityEnum["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    StoreItemValidityEnum["PRICE_MISMATCH"] = "PRICE_MISMATCH";
    StoreItemValidityEnum["MISSING_SUB_ITEM"] = "MISSING_SUB_ITEM";
    StoreItemValidityEnum["VALIDATION_FAILED"] = "VALIDATION_FAILED";
    StoreItemValidityEnum["EXCEEDED_MAX_QUANTITY"] = "EXCEEDED_MAX_QUANTITY";
    StoreItemValidityEnum["SUBSIDED_MIN_QUANTITY"] = "SUBSIDED_MIN_QUANTITY";
    StoreItemValidityEnum["SLOT_CAPACITY_EXCEEDED"] = "SLOT_CAPACITY_EXCEEDED";
    StoreItemValidityEnum["REQUIRED_PROPERTY_NOT_SELECTED"] = "REQUIRED_PROPERTY_NOT_SELECTED";
    StoreItemValidityEnum["SELECTED_TIME_SLOT_UNAVAILABLE"] = "SELECTED_TIME_SLOT_UNAVAILABLE";
})(StoreItemValidityEnum || (StoreItemValidityEnum = {}));
//# sourceMappingURL=StoreItemValidityEnum.js.map